// extracted by mini-css-extract-plugin
module.exports = {"tabsWrapper":"styles_tabsWrapper__1joMc","tabsContainer":"styles_tabsContainer__2Y3ix","tabItem":"styles_tabItem__3pmx6","activeTab":"styles_activeTab__2PvpQ"};